<section class="surface-elevated p-6 sm:p-8" style="opacity: 1; transform: none;">
    <div class="mb-6 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <h2 class="flex items-center gap-2 text-2xl font-semibold text-text-primary">
            <i class="fas fa-building text-xl text-primary"></i>
            {{ 'experts.properties.title' | translate }} ({{ expert?.propertiesCount || 0 }})
        </h2>
        @if ((expert?.propertiesCount || 0) > 0) {
            <button class="btn btn-ghost text-primary">
                {{ 'experts.properties.viewAll' | translate }}
                <i class="fas fa-chevron-right ms-1 text-[10px] rtl:rotate-180"></i>
            </button>
        }
    </div>
    @if (!expert?.propertiesCount) {
        <div class="rounded-lg border border-border-subtle bg-surface p-8 text-center">
            <i class="fas fa-building mb-4 text-4xl text-text-muted opacity-50"></i>
            <h3 class="mb-2 font-semibold text-text-primary">{{ 'experts.properties.emptyTitle' | translate }}</h3>
            <p class="text-sm text-text-secondary">{{ 'experts.properties.emptyDescription' | translate }}</p>
        </div>
    }
</section>
